import React, { useState, useEffect } from 'react';
import '../../css/GardenAlertStylings.css';

// Alert types: ["Success", "Error", "Neutral"]
const GardenAlert = ({
                         alertSubject = "System",
                         alertMessage,
                         alertType = "Neutral",
                         isVisible = false,
                         onClose
                     }) => {
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        if (isVisible) {
            // Trigger animation after component mounts
            setTimeout(() => setIsAnimating(true), 10);
        } else {
            setIsAnimating(false);
        }
    }, [isVisible]);

    const handleCloseAlert = () => {
        setIsAnimating(false);
        // Wait for animation to complete before calling onClose
        setTimeout(() => {
            onClose && onClose();
        }, 300);
    };

    const handleContainerClick = (e) => {
        // Prevent closing when clicking on the alert itself
        e.stopPropagation();
    };

    if (!isVisible) return null;

    return (
        <div
            className="garden-alert-background-overlay"
            onClick={handleCloseAlert}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
                zIndex: 9999,
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-start',
                padding: '20px'
            }}
        >
            <div
                className={`garden-alert-container garden-alert-${alertType.toLowerCase()}`}
                onClick={handleContainerClick}
                style={{
                    transform: isAnimating ? 'translateX(0)' : 'translateX(100%)',
                    transition: 'transform 0.3s ease-out',
                    maxWidth: '400px',
                    width: '100%',
                    padding: '16px',
                    borderRadius: '8px',
                    border: '1px solid',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                    cursor: 'default'
                }}
            >
                <div className="garden-alert-body">
                    <div className="garden-alert-main-content">
                        <div
                            className="garden-alert-subject"
                            style={{
                                fontWeight: '600',
                                fontSize: '16px',
                                marginBottom: '8px'
                            }}
                        >
                            {alertSubject}
                        </div>

                        <div
                            className="garden-alert-message"
                            style={{
                                fontSize: '14px',
                                lineHeight: '1.4',
                                marginBottom: '12px'
                            }}
                        >
                            {alertMessage}
                        </div>

                        <div className="garden-alert-footer">
                            <button
                                className="garden-alert-footer-button"
                                onClick={handleCloseAlert}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: 'inherit',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    padding: '4px 0'
                                }}
                            >
                                Dismiss
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GardenAlert;